import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { LoginModel } from 'src/app/model/login.model';
import { AuthenticationService } from '../services/authentication.service';
import { ExtendedMatTableComponent } from '../components/extended-mat-table/extended-mat-table.component';
import { ActivatedRoute, Router } from '@angular/router';
import { SubfrotaService } from '../subFrota/subfrota.service';
import { Subscription } from 'rxjs';
import { MatSortable } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SnackBarService } from '../services/snack-bar-service.service';
import { ISubFrotaModel } from '../subFrota/model/subFrota.model';
import { TipoEntidades } from '../subFrota/model/TipoEntidades';
import { IFiltroRegistroTransacoesViewModel, IFiltroTransacoesViewModel } from '../relatorios/model/filtro-transacoes-view-model';
import { ITransacoes } from '../subFrota/model/abastecimentos-view-model';
import { RegistroTransacoesService } from './registro-transacoes.service';
import { FiltroComponent } from './filtro/filtro.component';
import { MatDialog } from '@angular/material/dialog';
import { DetalheRegistroTransacaoComponent } from './detalhe-registro-transacao/detalhe-registro-transacao.component';

/*

enum TipoEntidades {
  ctf = 1,
  frota = 2,
  posto = 3,
  macro = 8
}
*/

@Component({
  selector: 'app-registro-transacoes',
  templateUrl: './registro-transacoes.component.html',
  styleUrls: ['./registro-transacoes.component.scss']
})
export class RegistroTransacoesComponent implements OnInit {

  usuario !: LoginModel | undefined;
  public tituloFuncionalidade: any = "";
  public columnRowData: any = "";
  public columns: any[] = [];

  @ViewChild(ExtendedMatTableComponent) extendedTable!: any;
  @ViewChild(FiltroComponent) appFiltro!: any;
  private subs = new Subscription();

  filtro!: IFiltroRegistroTransacoesViewModel;
  public dataSource: any[] = [];
  tipoEntidades = TipoEntidades;

  loading: number = 0;
  isCollapsed!: boolean;

  templateColunas = [
    {
      cmdName: 1,
      tituloRelatorio: "Transações",
      filtro: [],
      colunas: [
        {
          columnDef: "daT_ABASTECIMENTO", header: "Data", format: null, multiValor: true, separador: "br", campos: [
            { columnDef: "", campo: "daT_ABASTECIMENTO", format: "date", cssClass: '' },
            { columnDef: "", campo: "daT_ABASTECIMENTO", format: "time", cssClass: '' },
          ]
        },
        {
          columnDef: "dsC_PLACA", header: "Placa", format: null, multiValor: true, separador: "br", campos: [
            { columnDef: "", campo: "dsC_PLACA", format: null, cssClass: '' },
            { columnDef: "", campo: "pB5_MODELO", format: null, cssClass: 'texto-menor' },
          ]
        },
        {
          columnDef: "dsC_NOME", header: "Motorista", format: null, multiValor: true, separador: "br", campos: [
            { columnDef: "", campo: "dsC_NOME", format: null, cssClass: '' },
            { columnDef: "CPF: ", campo: "nuM_CPF", format: "cpf", cssClass: 'texto-menor' },
            { columnDef: "Cel: ", campo: "nuM_CELULAR", format: null, cssClass: 'texto-menor' },
          ]
        },
        {
          columnDef: "pA7_NREDUZ", header: "Posto", format: null, multiValor: true, separador: "br", campos: [
            { columnDef: "", campo: "pA7_NREDUZ", format: null, cssClass: '' },
            { columnDef: "", campo: "nM_CIDADE", format: null, cssClass: 'texto-menor' },
            { columnDef: "", campo: "cD_UF", format: null, cssClass: 'texto-menor' },
          ]
        },
        { columnDef: "zE_DESCRIC", header: "Combustível", format: null },
        { columnDef: "qtD_VOLUME", header: "Litros", format: null },
        { columnDef: "vlR_UNITARIO_DESCONTO", header: "Valor Litro", format: "numeric2" },
        { columnDef: "vlR_TOTAL", header: "Valor Total", format: "currency" },
        { columnDef: "dsC_TIPOPRODUTO", header: "Pagamento", format: null },
        { columnDef: "situacao", header: "Status", format: null },
        { columnDef: "coD_ERRO", header: "Erro", format: null },
        { columnDef: "dsC_MENSAGEM_RETORNO", header: "Motivo", format: null },
        {
          columnDef: "ACAO_DETALHES", header: "Detalhes", tituloMenu: "teste", format: null, orderBy: false, cssClass: "menuAcao", actions: [
            {
              titulo: "Ver mais", link: "openDetalheTransacao", tipo: "FUNCTION_ROW", cssClass: "btnVermais", parametros: [
                { "nome": "ROW", "valor": "ROW" }
              ]
            }
          ]
        }
      ],
      columnDefinitions:
        { columnDef: "ROW_COLOR", condition: "return row.situacao.toString() == 'Rejeitada' ? 'pintarLinhaTransacaoNegadas' : '';" }

    }
  ];
  //public dataSource: any[] = [];

  constructor(
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private registroTransacoesService: RegistroTransacoesService,
    private cdr: ChangeDetectorRef,
    private snackBar: SnackBarService,
    private renderer: Renderer2,
    private router: Router,
    public dialog: MatDialog,
    //private extendedMatTable: ExtendedMatTableComponent
  ) {

    this.usuario = this.registroTransacoesService?.usuario;
  }


  ngOnInit(): void {
    this.columns = this.configurarDadosTela();
    this.usuario = this.authenticationService.getDadosUserLocal();

    this.loading++;

    this.authenticationService.validate(this.registroTransacoesService?.usuario?.retorno?.guid ?? '')
      .then((dados => {

        if (!dados.sucesso) {

          this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
          this.usuario = undefined;

        } else {
          this.iniciar();
        }
      }))
      .catch(() => {
        this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
      })
      .finally(() => {
        this.loading--;
      });

  }

  public chamadaFiltro(filtro: IFiltroRegistroTransacoesViewModel | null) {
    console.log(filtro);
    if (filtro != null)
      this.filtro = filtro;

    this.filtrar();
  }

  private iniciar() {
    this.renderer.addClass(document.body, this.usuario?.retorno?.aparencia ?? "PADRAO");
    this.recuperaFiltroFrota();

    // Se usuário for de Frota ou Macro já realiza a consulta ao abrir a tela, senão é necessário escolher a frota antes de filtrar.
    if ((this.usuario?.retorno?.tipo === this.tipoEntidades.frota || this.usuario?.retorno?.tipo === this.tipoEntidades.macro) || (this.filtro.codFrota)) {
      this.isCollapsed = true;
      this.filtrar();
    }
    else {
      this.isCollapsed = false;
    }
  }

  private recuperaFiltroFrota() {
    if (sessionStorage.getItem('filtroSubFrota')) {
      var localFiltro = JSON.parse(sessionStorage.getItem('filtroSubFrota') ?? '{}');
      if (localFiltro.guid === this.filtro?.guid) {
        this.filtro = localFiltro;
      }
      sessionStorage.removeItem('filtroSubFrota');
    }

    if (sessionStorage.getItem('filtroFrota')) {

      var filtroFrota = JSON.parse(sessionStorage.getItem('filtroFrota') ?? '{}');
      this.filtro.codFrota = undefined;

      if (filtroFrota.guid === this.registroTransacoesService.usuario.retorno.guid) {
        if (filtroFrota.frota && filtroFrota.frota.codigo) {
          this.filtro.codFrota = filtroFrota.frota.codigo
        }
      } else {
        sessionStorage.removeItem('filtroFrota');
      }
    }
  }

  getXLSName(): string {
    const now = new Date();
    var name = 'CTF_' + this.tituloFuncionalidade + '_' + now.toISOString();
    return name;
  }

  exportTable(format: string) {
    //, {fileName: getXLSName(), sheet: 'SubFrotas', Props: {Author: 'CTF'}}
    this.extendedTable.exportData(format, this.getXLSName(), 'CTF');
  }

  public configurarDadosTela(): any[] {
    var retornoId = 1;
    //console.log(retornoId);
    var result = this.templateColunas.find(template => template.cmdName === retornoId);

    this.tituloFuncionalidade = result?.tituloRelatorio;
    if (result?.columnDefinitions) {
      this.columnRowData = result?.columnDefinitions;
    }

    return result ? result.colunas : [];
  }

  private filtrar() {
    if (this.filtro == null) {
      this.filtro = this.appFiltro.filtro;
    }

    if (this.usuario?.retorno?.tipo != this.tipoEntidades.frota && this.usuario?.retorno?.tipo != this.tipoEntidades.macro && !this.filtro.codFrota) {
      this.snackBar.flashMessage('Favor selecionar uma Frota no filtro.', ['snackbar-error'], 'Fechar', 0);

    } else {

      this.loading++;
      var retorno: any;//this.subFrotaService.obterListaTransacoes(this.filtro);
      this.subs.add(this.registroTransacoesService.obterListaTransacoes(this.filtro)
        .subscribe({
          next: (res) => {
            if (res?.sucesso) {
              retorno = res.retorno;
              this.dataSource = res.retorno as any[];
            }
          },
          complete: () => {
            this.loading--;
            //console.log('fim')
            this.extendedTable.dataSource = this.dataSource;
            this.extendedTable.atualizaDados();
            //this.cdr.detectChanges();
          }
        })
      );
    }
  }

  private buildUrlWithParams(link: string, params: any[] | undefined, row: any): string {
    const url = new URL(link, window.location.origin);

    if (params != undefined) {
      params.forEach(param => {
        const value = row[param.valor]; // Obtém o valor do row baseado no campo 'valor'
        if (value !== undefined) {
          url.searchParams.append(param.nome, value);
        }
      });
      if (this.usuario != undefined)
        url.searchParams.append("userGuid", this.usuario?.retorno.guid);
    }
    return url.toString();
  }

  openDetalheTransacao(dados: any) {
    //console.log(dados);
    const dialogRef = this.dialog.open(DetalheRegistroTransacaoComponent, { width: '950px', height: '700px', data: dados });
  }

  
}
